module.exports = __webpack_public_path__ + "./assets/d2ecec20a07912fb23b9948c97104636.jpg";